var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenbg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 722,
    viewBox: "0 0 1600 722",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1 634.089L66 619.437C133 604.785 266 575.482 400 487.57C533 399.659 667 251.309 801 148.746C934 46.1835 1068 -12.4239 1201 2.228C1335 16.8798 1468 104.791 1535 148.746L1602 192.702V722H1535C1468 722 1335 722 1201 722C1068 722 934 722 801 722C667 722 533 722 400 722C266 722 133 722 66 722H-1V634.089Z",
    fill: "#C8DDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenbg);
export default __webpack_public_path__ + "static/media/Green bg.7f9b3cdd88492c47ed72d16a87d33cb8.svg";
export { ForwardRef as ReactComponent };